// extracted by mini-css-extract-plugin
export default {"container":"container-c8Yk8qRY","pieces":"pieces-joVSgyMo"};